export const anchorLinks = [
  {
    anchor: 'team',
    alias: '#team',
    title: 'Команда',
  },
  {
    anchor: 'program',
    alias: '#program',
    title: 'Программа',
  },
  {
    anchor: 'address',
    alias: '#address',
    title: 'Как нас найти',
  },
];
